// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildWorkItemTestcase,
  BuildWorkItemTestcaseFromJSON,
  BuildWorkItemTestcaseToJSON,
} from "./";

/**
 *
 * @export
 * @interface BuildWorkItem
 */
export interface BuildWorkItem {
  /**
   *
   * @type {string}
   * @memberof BuildWorkItem
   */
  provider: string;
  /**
   * TestCollab requirement database ID used for internal requirement links.
   * @type {number}
   * @memberof BuildWorkItem
   */
  localRequirementId: number;
  /**
   * Deprecated for requirement-derived work items; returned as null.
   * @type {number}
   * @memberof BuildWorkItem
   */
  profileId?: number;
  /**
   *
   * @type {string}
   * @memberof BuildWorkItem
   */
  issueKey: string;
  /**
   *
   * @type {number}
   * @memberof BuildWorkItem
   */
  issueId?: number;
  /**
   *
   * @type {string}
   * @memberof BuildWorkItem
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof BuildWorkItem
   */
  issueType?: string;
  /**
   *
   * @type {string}
   * @memberof BuildWorkItem
   */
  issueStatus?: string;
  /**
   *
   * @type {string}
   * @memberof BuildWorkItem
   */
  issueUrl?: string;
  /**
   * Deprecated for Build traceability; reciprocal-link state is managed per live requirement relation.
   * @type {string}
   * @memberof BuildWorkItem
   */
  syncStatus?: string;
  /**
   *
   * @type {number}
   * @memberof BuildWorkItem
   */
  testcaseCount: number;
  /**
   *
   * @type {Array<BuildWorkItemTestcase>}
   * @memberof BuildWorkItem
   */
  testcases: Array<BuildWorkItemTestcase>;
}

export function BuildWorkItemFromJSON(json: any): BuildWorkItem {
  return {
    provider: json["provider"],
    localRequirementId: json["local_requirement_id"],
    profileId: !exists(json, "profile_id") ? undefined : json["profile_id"],
    issueKey: json["issue_key"],
    issueId: !exists(json, "issue_id") ? undefined : json["issue_id"],
    title: !exists(json, "title") ? undefined : json["title"],
    issueType: !exists(json, "issue_type") ? undefined : json["issue_type"],
    issueStatus: !exists(json, "issue_status")
      ? undefined
      : json["issue_status"],
    issueUrl: !exists(json, "issue_url") ? undefined : json["issue_url"],
    syncStatus: !exists(json, "sync_status") ? undefined : json["sync_status"],
    testcaseCount: json["testcase_count"],
    testcases: (json["testcases"] as Array<any>).map(
      BuildWorkItemTestcaseFromJSON
    ),
  };
}

export function BuildWorkItemToJSON(value?: BuildWorkItem): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    provider: value.provider,
    local_requirement_id: value.localRequirementId,
    profile_id: value.profileId,
    issue_key: value.issueKey,
    issue_id: value.issueId,
    title: value.title,
    issue_type: value.issueType,
    issue_status: value.issueStatus,
    issue_url: value.issueUrl,
    sync_status: value.syncStatus,
    testcase_count: value.testcaseCount,
    testcases: (value.testcases as Array<any>).map(BuildWorkItemTestcaseToJSON),
  };
}
